import { PlusCircleIcon, TrashIcon } from '@heroicons/react/24/solid'
import { SliderDropdown as SliderDropdownType, Type, SliderDropdownGroup as SliderDropdownGroupType } from '../../../../../../types/Survey/Element'
import { Props } from './types'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import DNDList from '../../../../../UI/DNDList/DNDList'
import Core from './Core'
import getTemplateElement from '../../AddElement/getTemplateElement'
import RemoveConfirmation from '../../../../../UI/RemoveConfirmation/RemoveConfirmation'
import SliderDropdown from './SliderDropdown'

const SliderDropdownGroup: React.FC<Props<SliderDropdownGroupType>> = ({ element, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const updateSlider = (uuid: string) => (slider: SliderDropdownType) => {
    const updatedElements = element.sliderDropdowns.map((s) => (s.uuid === uuid ? slider : s))
    update({ ...element, sliderDropdowns: updatedElements })
  }

  const updateSliderOrder = (sliderDropdowns: SliderDropdownType[]) => update({ ...element, sliderDropdowns })

  const remove = (uuid: string) => () => {
    const newElements = element.sliderDropdowns.filter((e) => e.uuid !== uuid)
    update({ ...element, sliderDropdowns: newElements })
  }

  const Add = () => {
    const add = () => {
      const newSlider = getTemplateElement(Type.SLIDER_DROPDOWN) as SliderDropdownType
      update({ ...element, sliderDropdowns: [...element.sliderDropdowns, newSlider] })
    }

    return (
      <div className="flex gap-1 items-center mt-3 cursor-pointer w-fit" onClick={add}>
        <PlusCircleIcon className="w-10 fill-cyan" />
        <div className="">{t.survey.configuration.sliderDropdownGroup.add}</div>
      </div>
    )
  }

  return (
    <div>
      <Core element={element} update={update} />
      <div className="mt-1">
        <DNDList
          orderUpdateCallback={updateSliderOrder}
          invert
          items={element.sliderDropdowns.map((s: SliderDropdownType, index: number) => {
            return {
              id: s.uuid,
              data: s,
              content: (
                <div key={s.uuid} className="flex flex-row items-start bg-lightGray border-b border-cyan border-opacity-20 py-2 px-2 gap-3">
                  <div className="flex flex-col items-center gap-3">
                    <div className="w-6 aspect-square bg-cyan rounded-full flex items-center justify-center text-white">{index + 1}</div>
                    {index > 1 && (
                      <RemoveConfirmation itemName={s.title} confirmationCallback={remove(s.uuid)}>
                        <TrashIcon className="fill-blue opacity-40 hover:opacity-100 transition-all w-6 cursor-pointer" />
                      </RemoveConfirmation>
                    )}
                  </div>
                  <div className="flex flex-col w-full">
                    <SliderDropdown key={s.uuid} element={s} update={updateSlider(s.uuid)} disableCounterWeight />
                  </div>
                </div>
              ),
            }
          })}
        />
      </div>
      <Add />
    </div>
  )
}

export default SliderDropdownGroup
